import { DashboardGraphModel, DashboardPublicationAnalysisFilter, DashboardPublicationAnalysisSummaryColumn } from "models/ApiModels";
import { RenderTopicModelListEvents } from "views/Dashboards/components/RenderTopicModelList";
import { RenderUserModelListEvents } from "views/Dashboards/components/RenderUserModelList";

/////////////////////////////////////////////////////////////////////////////////////

export enum DashboardPublicationAnalysisGraphPeriod { Last30, Last12 }

export enum DashboardPublicationAnalysisListPeriod { Last30, All }

export interface IDashboardPublicationAnalysisGraphProps extends RenderUserModelListEvents, RenderTopicModelListEvents {
    tile: DashboardPublicationAnalysisSummaryColumn;
    filter: DashboardPublicationAnalysisFilter;
}

export interface IDashboardPublicationAnalysisGraphState {
    data: DashboardGraphModel[];
    loading: boolean;
    tabOption?: DashboardPublicationAnalysisGraphPeriod;
    selectedDay?: Date;
}

export interface IDashboardPublicationAnalysisListProps extends RenderUserModelListEvents, RenderTopicModelListEvents {
    tile: DashboardPublicationAnalysisSummaryColumn;
    filter: DashboardPublicationAnalysisFilter;
    graphPeriod: DashboardPublicationAnalysisGraphPeriod;
    selectedDay: Date;
    onCancelDay: () => void;
}

/////////////////////////////////////////////////////////////////////////////////////